export default {
  name: 'max-fee-metadata-mixin',
  props: {
    isProgramBasedMode: {
      type: Boolean,
      default: false,
    },
    programOptions: Array,
  },
  computed: {
    maxDiscountDescription() {
      if (!this.schedule.allowMaxDiscount) {
        return this.translate('noDiscountAllowed');
      }
      return this.translate('discountAllowedWithAnnualFeeNoLessThanMeta', {
        noLessThan: this.formatNumber(this.schedule.annualFeeNoLessThan, 'shortDecimal'),
        maxDiscount: this.formatNumber(this.schedule.maxDiscount, 'shortDecimal'),
      });
    },
    validSelectedProgramsString() {
      const result = [];
      if (this.schedule.programList) {
        this.schedule.programList.forEach(id => {
          const validSelectedOption = this.programOptions.find(option => option.value === id);
          if (validSelectedOption) {
            result.push(validSelectedOption);
          }
        });
      }
      if (result.length > 0) {
        return result.map(option => option.text).join(', ');
      }
      return this.translate('noProgramAssigned');
    },
  },
};
